(() => {
  const numberOr = (value, fallback) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const clampQuantity = (input, value) => {
    const min = numberOr(input.min, 1);
    const step = Math.max(numberOr(input.step, 1), 1);
    const max = input.max === "" ? Number.POSITIVE_INFINITY : numberOr(input.max, Number.POSITIVE_INFINITY);
    const stepped = min + Math.round((numberOr(value, min) - min) / step) * step;
    return Math.min(Math.max(stepped, min), max);
  };

  const initializeGallery = (root) => {
    const mainImage = root.querySelector("[data-pqy-product-main-image]");
    const thumbnails = [...root.querySelectorAll("[data-pqy-product-thumbnail]")];
    if (!mainImage || thumbnails.length === 0) return;

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", () => {
        const width = numberOr(thumbnail.dataset.width, mainImage.width);
        const height = numberOr(thumbnail.dataset.height, mainImage.height);
        mainImage.src = thumbnail.dataset.src;
        mainImage.removeAttribute("srcset");
        mainImage.removeAttribute("sizes");
        mainImage.alt = thumbnail.dataset.alt || "";
        mainImage.width = width;
        mainImage.height = height;
        mainImage.style.setProperty("--pqy-source-width", `${width}px`);
        mainImage.style.setProperty("--pqy-source-height", `${height}px`);

        thumbnails.forEach((item) => {
          const selected = item === thumbnail;
          item.classList.toggle("is-selected", selected);
          item.setAttribute("aria-pressed", String(selected));
        });
      });
    });
  };

  const initializeQuantity = (root) => {
    const input = root.querySelector("[data-pqy-quantity-input]");
    if (!input) return;

    root.querySelectorAll("[data-pqy-quantity-action]").forEach((button) => {
      button.addEventListener("click", () => {
        const direction = button.dataset.pqyQuantityAction === "increase" ? 1 : -1;
        const step = Math.max(numberOr(input.step, 1), 1);
        input.value = String(clampQuantity(input, numberOr(input.value, 1) + direction * step));
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    input.addEventListener("change", () => {
      input.value = String(clampQuantity(input, input.value));
    });
  };

  const initializeVariants = (root) => {
    const variantField = root.querySelector("[data-pqy-product-variant]");
    if (!(variantField instanceof HTMLSelectElement)) return;

    const price = root.querySelector("[data-pqy-current-price]");
    const comparePrice = root.querySelector("[data-pqy-compare-price]");
    const sku = root.querySelector("[data-pqy-current-sku]");
    const status = root.querySelector("[data-pqy-current-status]");
    const quantity = root.querySelector("[data-pqy-quantity-input]");
    const addButton = root.querySelector("[data-pqy-add-to-cart]");

    const sync = () => {
      const option = variantField.selectedOptions[0];
      if (!option) return;
      const available = option.dataset.available === "true";
      const hasCompare = option.dataset.hasCompare === "true";

      if (price) price.textContent = option.dataset.price || "";
      if (sku) sku.textContent = option.dataset.sku || "";
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || "";
        comparePrice.hidden = !hasCompare;
      }
      if (status) {
        const dot = status.querySelector("i");
        const label = status.querySelector("strong");
        if (dot) dot.classList.toggle("is-available", available);
        if (label) label.textContent = available ? root.dataset.inStockLabel : root.dataset.soldLabel;
      }
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? root.dataset.addLabel : root.dataset.soldLabel;
      }
      if (quantity) {
        quantity.min = option.dataset.min || "1";
        quantity.step = option.dataset.step || "1";
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute("max");
        quantity.value = String(clampQuantity(quantity, quantity.value));
      }
    };

    variantField.addEventListener("change", sync);
    sync();
  };

  const initializeSectionNavigation = (root) => {
    const links = [...root.querySelectorAll(".pqy-native-section-nav a")];
    if (links.length === 0) return;

    links.forEach((link) => {
      link.addEventListener("click", () => {
        links.forEach((item) => item.classList.toggle("is-active", item === link));
      });
    });
  };

  const initializeProduct = (root) => {
    if (root.dataset.pqyProductInitialized === "true") return;
    root.dataset.pqyProductInitialized = "true";
    initializeGallery(root);
    initializeQuantity(root);
    initializeVariants(root);
    initializeSectionNavigation(root);
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll("[data-pqy-product-root]").forEach(initializeProduct);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
})();
